import React, { useState } from 'react';
import { withStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import PF2MTabs from '~/components/PF2MTabs';
import OperationalControl from './OperationalControl';
import styles from './styles';

const LoadSchedules = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const { t: translate } = useTranslation();
  const tabs = [
    { key: 0, label: translate('common:OperationalControl') },
  ];

  const handleChange = (_event, value) => {
    setSelectedTab(value);
  };

  return (
    <>
      <PF2MTabs
        value={selectedTab}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        hideSyncButton
      >
        {tabs}
      </PF2MTabs>
      {selectedTab === 0 ? (<OperationalControl />) : null}
    </>
  );
};

export default withStyles(styles)(LoadSchedules);
